<template>
  <layout-content>
    <tabs type="card" :animated="false" :value="current_tab" @on-click="show_tab">
      <tab-pane
        v-for="tab in ['group', 'contact', 'sip-account']"
        :key="tab"
        :name="tab"
        :label="$t(`pbx.breadcrumb.${tab}.index`)"
      />
    </tabs>
    <router-view />

    <template slot="top-buttons">
      <template v-if="current_tab === 'contact'">
        <tooltip
          v-if="!is_allow_create_contact"
          class="text-left"
          max-width="200"
          placement="bottom-end"
          theme="light"
        >
          <div slot="content" class="text-left">{{ $t('pbx.service-package.limit.contacts') }}</div>

          <i-button
            slot="default"
            v-bind="default_button_props"
            :disabled="!is_allow_create_contact"
          >
            {{ default_button_text }}
          </i-button>
        </tooltip>

        <i-button v-else v-bind="default_button_props">
          {{ default_button_text }}
        </i-button>
      </template>

      <template v-else>
        <i-button v-bind="default_button_props">
          {{ default_button_text }}
        </i-button>
      </template>
    </template>
  </layout-content>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { TOTAL_ITEMS } from '@app/plugins/vuex-async-pagginate';

  export default {
    computed: {
      ...mapGetters('pbx/contacts/table', { total_contacts: TOTAL_ITEMS }),

      limit_contacts: function() {
        try {
          return this.$user.pbx.limit_contacts;
        } catch (e) {
          return 0;
        }
      },

      current_tab: function() {
        const path_of_name = this.$route.name.split('.');
        return path_of_name[1];
      },

      default_button_props: function() {
        return {
          type: 'primary',
          size: 'large',
          to: { name: `pbx.${this.current_tab}.create` }
        };
      },

      default_button_text: function() {
        return this.$t(`pbx.breadcrumb.${this.current_tab}.create`);
      },

      is_allow_create_contact: function() {
        return this.total_contacts < this.limit_contacts;
      }
    },

    methods: {
      show_tab(name) {
        const path_name = `pbx.${name}.index`;
        this.$router.push({ name: path_name });
      }
    }
  };
</script>
